/**
 * Game screen setup
 * Handles initialization of features when showing the game screen
 */

import { setupParallaxBackground } from '../../features/parallax'
import { setupBackgroundTexture } from '../../features/background-texture'
import { setupScrollSpeedControl, setupChapterTitleOverlay } from '../../features/scroll-speed'
import type { LenisInstance } from '../../features/lenis/types'
import type storyData from '../../config/story.json'

type StoryData = typeof storyData

/**
 * Setup all game screen features
 * @param lenisInstance - Lenis instance
 * @param storyEngine - Story engine instance
 * @param storyData - Story data
 * @param app - App container
 */
export function setupGameScreenFeatures(
  lenisInstance: LenisInstance | null,
  storyEngine: { getScrollSpeedConfig: () => any },
  storyData: StoryData,
  app: HTMLElement
): void {
  if (!lenisInstance) return

  const frameCallbacks = lenisInstance.frameCallbacks

  // Setup background texture (each chapter-title in story defines its own "background" in /assets/images/)
  const backgroundTextureInstance = setupBackgroundTexture(
    storyData.scenes as any,
    frameCallbacks
  )
  ;(window as any).__backgroundTextureInstance = backgroundTextureInstance

  // Yellow overlay for chapter titles — works with or without Lenis
  setupChapterTitleOverlay(app, frameCallbacks)

  if (lenisInstance.lenis) {
    setupScrollSpeedControl(
      lenisInstance.lenis,
      () => storyEngine.getScrollSpeedConfig(),
      frameCallbacks,
      app
    )
    const parallaxInstance = setupParallaxBackground(lenisInstance.lenis)
    ;(window as any).__parallaxInstance = parallaxInstance
  }
}
